import React from 'react';
import { isEmpty, find, cloneDeep } from 'lodash';
import { Link } from 'react-router-dom';

import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import ACButton from '../../atoms/ACButton';
import { getInternalBaseUrl } from '../../common/global.js';

import styles from './MoreToExploreList.module.scss';

export default class MoreToExploreList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onSelectMoreToExplore(moreToExploreId) {
    this.props.onSelectMoreToExploreFunc(moreToExploreId);
  }

  onClickMoreToExplore(moreToExploreId) {
    const moreToExplore = find(this.props.moreToExploreCollection, mte => {
      return mte.id === moreToExploreId;
    });

    if (!isEmpty(moreToExplore)) {
      console.log('mte', moreToExplore);
      this.props.onSelectMoreToExploreFunc(cloneDeep(moreToExplore));
    }
  }

  onCreateMoreToExplore() {
    this.props.onCreateMoreToExploreFunc();
  }

  onChangeText(e) {
    this.reset();
    this.props.onSearchMoreToExploreFunc(e.target.value);
  }

  renderMoreToExploreCollection() {
    const { moreToExploreCollection } = this.props;
    if (isEmpty(moreToExploreCollection)) return;

    return moreToExploreCollection.map(moreToExplore => {
      return this.renderMoreToExplore(moreToExplore);
    });
  }

  renderMoreToExplore(moreToExplore) {
    if (!moreToExplore) return;
    const { id = '', name = '', address = '' } = moreToExplore;
    const mte = this.props.moreToExplore;

    let gotToMoreToExploreUrl = getInternalBaseUrl().moreToExploreCollection + '?id=' + id;
    let s = [styles.moreToExploreListItem];
    if (mte && mte.id === moreToExplore.id) {
      s.push(styles.selected);
    }
    return (
      <ListItem className={s.join(' ')} key={id}>
        <div style={{ width: '100%' }}>
          <Link
            to={gotToMoreToExploreUrl}
            style={{ textDecoration: 'none', color: 'inherit', width: '100%', padding: '10px' }}
            onClick={() => this.onClickMoreToExplore(id)}
          >
            <div className={styles.moreToExploreName}>{name}</div>
            <div>{address}</div>
          </Link>
        </div>
      </ListItem>
    );
  }

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.header}>
            More to Explore List
            <ACButton
              text={'Add'}
              icon={<AddCircleOutlineIcon key="iconAddMoreToExplore" />}
              key="btnAddMoreToExplore"
              onClickFunc={() => this.onCreateMoreToExplore()}
            />
          </div>
          <TextField
            id="simple-start-adornment"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            moreToExploreholder="Search"
            className={styles.search}
            value={this.props.searchText}
            onChange={e => this.props.onChangeSearchTextFunc(e)}
          />
        </div>
        <div className={styles.bottom}>
          <List className={styles.moreToExploreList}>{this.renderMoreToExploreCollection()}</List>
        </div>
      </div>
    );
  }
}
